import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import BankingFAQs from '#client/components/BankingFAQs';

export default function PageTitle({ title, sx, to, appPageName, ...props }) {
  return (
    <Stack
      alignItems={{ xs: 'left', md: 'center' }}
      flexDirection={{ xs: 'column', md: 'row ' }}
      gap="16px"
      justifyContent="space-between"
      sx={sx}
      {...props}
    >
      <Heading
        family="secondary"
        size="3xl"
        weight="bold"
      >
        {title}
      </Heading>
      <BankingFAQs
        appPageName={appPageName}
        to={to}
      />
    </Stack>
  );
}

PageTitle.propTypes = {
  title: PropTypes.string.isRequired,
  to: PropTypes.string,
  appPageName: PropTypes.string,
  sx: PropTypes.shape({}),
  props: PropTypes.shape({})
};
